var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Oops!")]),_c('h3',[_vm._v("Cette page n'existe pas (ou plus).")]),_c('router-link',{attrs:{"to":{name: 'products-list'}}},[_vm._v("Retour à la page de réservation")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }